import React from 'react';
import { FormattedMessage } from 'react-intl';
// import { Formik } from 'formik';
// import * as Yup from 'yup';
// import Button from '../button';
import IntegrationBack from './integration-back';
import { ModalTitleSC, ModalCopySC } from '../modal/modal.styled';
// import Input from '../input';

type TProps = {
  onBack(): void;
  onDone(): void;
};

// type TFormValues = {
//   email: string;
//   name: string;
// };

// const formSchema = Yup.object().shape({
//   email: Yup.string().required('validation.required').email('validation.email'),
//   name: Yup.string().required('validation.required'),
// });

const IntegrationContact: React.FC<TProps> = ({ onDone, onBack }) => {
  // const initialValues: TFormValues = {
  //   email: '',
  //   name: '',
  // };

  // const onSubmit = (values: any) => {
  //   console.log(values);
  //   onDone();
  // };

  return (
    <div>
      <IntegrationBack onClick={onBack} />
      <ModalTitleSC>
        <FormattedMessage id="integration.contact_step.title" />
      </ModalTitleSC>
      <ModalCopySC>
        <FormattedMessage
          id="integration.contact_step.email_us"
          values={{ email: <a href="mailto:support@hilbi.com">support@hilbi.com</a> }}
        />
      </ModalCopySC>
      {/* <ModalCopySC>
        <FormattedMessage id="integration.contact_step.copy" />
      </ModalCopySC> */}
      {/* <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit}>
        {({ values, errors, handleSubmit, handleChange, touched }) => (
          <form onSubmit={handleSubmit}>
            <Input
              required
              type="email"
              label={<FormattedMessage id="integtatin.contact_step.email_label" />}
              placeholder="integtatin.contact_step.email_placeholder"
              name="email"
              value={values.email}
              onChange={handleChange}
              error={errors.email && touched.email && errors.email}
            />
            <Input
              required
              label={<FormattedMessage id="integtatin.contact_step.name_label" />}
              placeholder="integtatin.contact_step.name_placeholder"
              name="name"
              value={values.name}
              onChange={handleChange}
              error={errors.name && touched.name && errors.name}
              mb={64}
            />
            <Button text="integration.done" kind="PRIMARY" htmlType="submit" isBlock />
          </form>
        )}
      </Formik> */}
    </div>
  );
};

export default IntegrationContact;
